/* eslint-disable react/void-dom-elements-no-children */
/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-lone-blocks */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-undef */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unknown-property */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable max-len */
import React, {
    useState, useRef, useEffect, useCallback,
} from 'react';
import moment from 'moment';
import Checkbox from 'react-custom-checkbox';
import * as Icon from 'react-icons/fi';
import { Calendar } from 'react-calendar';
import { createUrl } from '../../../redux/helper/CreateQuery';
import { distributorService } from '../../../service/distributor.service';

function FilterModal({
    filterModal, setFilterModal, Filter, setFilter, filterValue, setfilterValue, selected, setselected, handleFilter, handlePendingOrderReports, threeplList, pendingOrderReportList, SetSuccessMessage,
}) {
    const dateRef = useRef();
    const orderTypes = ['Domestic', 'Free Service', 'Demo', 'Free Samples', 'Free Replacement', 'Service', 'Repair', 'Free Supplies'];
    const [selectedType, setselectedType] = useState('order_type');
    const [searchDropdown, setSearchDropdown] = useState(false);
    const toggleState = {
        start_date: false,
        end_date: false,
    };
    const [searchValue, serSearchValue] = useState('');
    const [distributorSearchResult, setdistributorSearchResult] = useState([]);

    const [toggle, settoggle] = useState(toggleState);

    const handleToggle = (key) => {
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
        }));
    };

    const onChangeSearch = (value) => {
        serSearchValue(value);
        distributorService.DistributorList(1, value, '', '').then((val) => {
            if (val.data.success_status) {
                setdistributorSearchResult(val.data.data);
            }
        });
    };

    useEffect(() => {
        distributorService.DistributorList(1, '', '', '').then((val) => {
            if (val.data.success_status) {
                setdistributorSearchResult(val.data.data);
            }
        });
    }, []);

    const handleDate = (val, key) => {
        const state = key === 'start_date' ? 'end_date' : 'start_date';
        if (key === 'start_date') {
            setselected((prevState) => ({
                ...prevState,
                end_date: '',
            }));
        }
        settoggle(toggleState);
        if (key === 'end_date') {
            settoggle(toggleState);
        } else {
            setTimeout(() => {
                handleToggle(state);
            }, 500);
        }
        setselected((prevState) => ({
            ...prevState,
            [key]: val,
        }));
        if (key === 'end_date') {
            settoggle(toggleState);
        }
    };

    const handleClear = () => {
        setFilter({
            order_type: [],
            plant_name: [],
            date_range: [],
            customer_code: [],
        });
        setselected({ start_date: '', end_date: '' });
        setfilterValue('');
        handlePendingOrderReports();
        setFilterModal(false);
        SetSuccessMessage('Filter(s) cleared');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 2000);
    };

    const HandleFilter = useCallback((key, val) => {
        const Filtercopy = { ...Filter };
        const idx = Filtercopy[key].indexOf(val);
        if (idx === -1) {
            Filtercopy[key].push(val);
        } else {
            Filtercopy[key].splice(idx, 1);
        }
        Filtercopy[key];
        setFilter(Filtercopy);
        return idx > -1;
        // return false
    }, []);

    const generateFilterQuery = (val) => {
        let final = '';
        Object.keys(Filter).map((key) => {
            switch (key) {
            case 'order_type':
                if (Filter[key].length > 0) {
                    final += `&order_type=${createUrl(Filter[key])}`;
                }
                break;
            case 'plant_name':
                if (Filter[key].length > 0) {
                    final += `&plant_name=${createUrl(Filter[key])}`;
                }
                break;
            case 'customer_code':
                if (Filter[key].length > 0) {
                    final += `&customer_code=${createUrl(Filter[key])}`;
                }
                break;
            default: break;
            }
            return final;
        });
        if (selected.start_date !== '' && selected.end_date !== '') {
            final += `&date_range=${moment(selected.start_date).format('DD-MM-YYYY')},${moment(selected.end_date).format('DD-MM-YYYY')}`;
        }
        if (val === undefined) {
            handleFilter(final);
        }
        setFilterModal(false);
        SetSuccessMessage('Filter(s) applied');
        setTimeout(() => {
            SetSuccessMessage('');
        }, 2000);
        return final;
    };

    useEffect(() => {
        const handler = (event) => {
            if (dateRef && !dateRef.current.contains(event.target)) {
                settoggle((prevState) => ({
                    ...prevState,
                    start_date: false,
                    end_date: false,
                }));
                // setNotificationDropdown(false)
                // setReportsDropdown(false)
            }
        };
        document.addEventListener('mousedown', handler);

        return () => {
            document.removeEventListener('mousedown', handler);
        };
    }, [dateRef]);

    return (
        <div className={`modal fade fixed top-0 left-0 ${filterModal ? 'show' : 'hidden'} w-full h-full outline-none overflow-x-hidden overflow-y-auto`} id="filtermodal" tabIndex="-1" aria-labelledby="deactivateOfferModal" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative w-auto pointer-events-none sm:max-w-[470px] mx-auto px-2.5" style={{ margin: 'auto' }}>
                <div
                    className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current"
                >
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md">
                        <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel1">
                            Filter
                        </h5>
                        <button
                            type="button"
                            className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute top-4 right-6"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            onClick={() => setFilterModal(false)}
                        >
                            <img src="/images/close.svg" alt="icon" />
                        </button>
                    </div>
                    <div className="modal-body relative sm:px-5 px-3 sm:pt-5 pt-4 sm:pb-7 pb-5 text-center">
                        <div className="flex items-start">
                            <ul className="nav nav-pills flex flex-col flex-wrap items-start list-none pl-0 w-[50%] h-full" id="pills-tabVertical" role="tablist">
                                <li className="nav-item flex-grow w-full text-start" role="presentation" onClick={() => setselectedType('order_type')}>
                                    <a
                                        href="#pills-pricetab"
                                        className={`nav-link block ${selectedType === 'order_type' ? 'active' : ''} text-base font-semibold text-[#AAA6AF] order relative w-full`}
                                        id="pills-priceranje"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-pricetab"
                                        role="tab"
                                        aria-controls="pills-price"
                                        aria-selected="true"
                                    >
                                        Order Type
                                    </a>
                                </li>
                                <li className="nav-item flex-grow text-start w-full my-4" role="presentation" onClick={() => setselectedType('plant_name')}>
                                    <a
                                        href="#pills-profileVertical "
                                        className={`nav-link block ${selectedType === 'plant_name' ? 'active' : ''} text-base font-semibold text-[#AAA6AF] order relative w-full`}
                                        id="pills-size"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-sizemm"
                                        role="tab"
                                        aria-controls="pills-sizemm"
                                        aria-selected="false"
                                    >
                                        Plant/Ware House
                                    </a>
                                </li>
                                <li className="nav-item flex-grow text-start w-full mb-4" role="presentation" onClick={() => setselectedType('date_range')}>
                                    <a
                                        href="#pills-profileVertical"
                                        className={`nav-link block ${selectedType === 'date_range' ? 'active' : ''} text-base font-semibold text-[#AAA6AF] order relative w-full`}
                                        id="pills-categories"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pillcategorie"
                                        role="tab"
                                        aria-controls="pillcategorie"
                                        aria-selected="false"
                                    >
                                        Date Range
                                    </a>
                                </li>
                                <li className="nav-item flex-grow text-start w-full" role="presentation" onClick={() => setselectedType('customer_code')}>
                                    <a
                                        href="#pills-profileVertical"
                                        className={`nav-link block ${selectedType === 'customer_code' ? 'active' : ''} text-base font-semibold text-[#AAA6AF] order relative w-full`}
                                        id="pills-type"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pilltype"
                                        role="tab"
                                        aria-controls="pillcategorie"
                                        aria-selected="false"
                                    >
                                        Customer Code
                                    </a>
                                </li>
                            </ul>
                            <div className="tab-content w-[70%] h-[192px] border-l border-[#D8D8D8]" id="pills-tabContentVertical">
                                <div className={`tab-pane ${selectedType === 'order_type' ? 'show active' : ''} fade px-3 w-full overflow-auto h-[190px] scrollbar-menu`} id="pills-pricetab" role="tabpanel" aria-labelledby="pills-priceranje">
                                    <div className="relative">
                                        <div className="cursor-pointer">
                                            {orderTypes.map((order, orderIndex) => (
                                                <div className="flex items-center mb-3" key={`type-${orderIndex}`}>
                                                    <Checkbox
                                                        icon={
                                                            <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.order_type?.includes(order) ? '#555259' : ''}` }} />
                                                        }
                                                        name="my-input"
                                                        className="cursor-pointer"
                                                        checked={Filter.order_type?.includes(order)}
                                                        onChange={() => HandleFilter('order_type', order)}
                                                        borderColor={`${Filter.order_type?.includes(order) ? '#B8C5DC' : '#555259'}`}
                                                        style={{ cursor: 'pointer' }}
                                                        labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                        id={order}
                                                    />
                                                    <label htmlFor={order} className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">
                                                        {' '}
                                                        {order}
                                                    </label>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                                <div className={`tab-pane ${selectedType === 'plant_name' ? 'show active' : ''}  fade w-full overflow-auto h-[190px] scrollbar-menu`} id="pills-sizemm" role="tabpanel" aria-labelledby="pills-size">
                                    <div className="ml-5 cursor-pointer">
                                        {threeplList.length > 0 && threeplList.map((location) => (
                                            <div className="flex items-center">
                                                <Checkbox
                                                    icon={
                                                        <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.plant_name?.includes(location.ORGANIZATION_ID) ? '#555259' : ''}` }} />
                                                    }
                                                    name="my-input"
                                                    className="cursor-pointer"
                                                    checked={Filter.plant_name.includes(location.ORGANIZATION_ID)}
                                                    onChange={() => HandleFilter('plant_name', location.ORGANIZATION_ID)}
                                                    borderColor={`${Filter.plant_name.includes(location.ORGANIZATION_ID) ? '#B8C5DC' : '#555259'}`}
                                                    style={{ cursor: 'pointer' }}
                                                    labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                />
                                                <label htmlFor="mn40" className="consumbales pl-3 text-sm font-normal text-[#090406] text-left cursor-pointer">{location.DESCRIPTION}</label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div ref={dateRef} className={`tab-pane ${selectedType === 'date_range' ? 'show active' : ''} fade  px-3`} id="pillcategorie" role="tabpanel" aria-labelledby="pills-categories">
                                    <div className="relative">
                                        <div className="flex sm:flex-row flex-col items-center mt-1 -mx-1">
                                            <div
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('start_date')}
                                            >
                                                <label />
                                                <img
                                                    src="/images/Iconawesome-calendar-alt.svg"
                                                    alt="icon"
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('start_date')}
                                                />
                                                <input
                                                    datepicker
                                                    datepicker-autohide
                                                    type="text"
                                                    value={selected.start_date === '' ? '' : moment(selected.start_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs2 placeholder:font-normal placeholder:text-[#808285]"
                                                    placeholder="From date"
                                                />
                                            </div>
                                            {toggle.start_date && (
                                                <Calendar
                                                    value={moment(selected.start_date).format('YYYY/MM/DD').start_date}
                                                    onChange={(val) => handleDate(val, 'start_date')}
                                                    placeholder="Date from"
                                                />
                                            )}
                                            <div
                                                className="relative sm:w-1/2 w-full px-1 mb-2"
                                                onClick={() => handleToggle('end_date')}
                                            >
                                                <label />
                                                <img
                                                    src="/images/Iconawesome-calendar-alt.svg"
                                                    alt="icon"
                                                    className="absolute top-3 right-2.5 cursor-pointer"
                                                    onClick={() => handleToggle('end_date')}
                                                />
                                                <input
                                                    datepicker
                                                    datepicker-autohide
                                                    type="text"
                                                    className="cursor-pointer h-[38px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-xs6 font-semibold text-[#090406] px-2.5 placeholder:text-xs2 placeholder:font-normal placeholder:text-[#808285]"
                                                    placeholder="To date"
                                                    value={selected.end_date === '' ? '' : moment(selected.end_date).format('YYYY/MM/DD').split('/').reverse()
                                                        .join('/')}
                                                />
                                            </div>
                                            {toggle.end_date && (
                                                <Calendar
                                                    value={selected.end_date}
                                                    onChange={(val) => handleDate(val, 'end_date')}
                                                    minDate={moment(selected.start_date).toDate()}
                                                    placeholder="Date to"
                                                />
                                            )}

                                        </div>
                                    </div>
                                </div>
                                <div className={`tab-pane ${selectedType === 'customer_code' ? 'show active' : ''} fade w-full px-3`} id="pilltype" role="tabpanel" aria-labelledby="pills-type">
                                    <div className="dropdown relative">
                                        <input
                                            type="text"
                                            id="distributors"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            autoComplete="off"
                                            value={searchValue}
                                            placeholder="Search Customer Code"
                                            className="dropdown-to h-[30px] w-[238px] outline-0 border rounded-t-[4px] border-[#D8D8D8] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5"
                                            onClick={() => setSearchDropdown(!searchDropdown)}
                                            onChange={(e) => {
                                                { onChangeSearch((e.target.value).trim()); }
                                            }}
                                        />
                                        {distributorSearchResult && searchDropdown && (
                                            <ul className={`dropdown-menu w-full ${searchDropdown ? '' : 'hidden'}absolute h-[145px] overflow-y-auto overflow-x-hidden bg-[#FFFFFF]  shadow-s2 z-[9999]`} aria-labelledby="HIP14">
                                                {distributorSearchResult.length > 0 && distributorSearchResult.map((ele, disIdx) => (
                                                    <li className="py-[8px] pl-[5px]">
                                                        <div className="flex items-center " key={disIdx}>
                                                            <Checkbox
                                                                icon={
                                                                    <Icon.FiCheck color="#FFFF" size={14} style={{ background: `${Filter.customer_code?.includes(ele.ACCOUNT_NUMBER) ? '#555259' : ''}` }} />
                                                                }
                                                                name="my-input"
                                                                className="cursor-pointer"
                                                                checked={Filter.customer_code?.includes(ele.ACCOUNT_NUMBER)}
                                                                onChange={() => HandleFilter('customer_code', ele.ACCOUNT_NUMBER)}
                                                                borderColor={`${Filter.customer_code?.includes(ele.ACCOUNT_NUMBER) ? '#B8C5DC' : '#555259'}`}
                                                                style={{ cursor: 'pointer' }}
                                                                labelStyle={{ marginLeft: 5, userSelect: 'none', cursor: 'pointer' }}
                                                            />
                                                            <label htmlFor="mn50" className="consumbales pl-3 text-sm46 font-normal text-[#090406] text-left cursor-pointer">{ele.ACCOUNT_NUMBER}</label>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="flex w-full">
                            <div className="pt-3 flex justify-end w-[50%] mr-5">
                                <button
                                    type="button"
                                    className="w-full sm:h-10 h-9 border-2 border-[#555259]  bg-[#FFFFFF] rounded-lg text-sm font-semibold filter1 text-[#555259]"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => handleClear()}

                                >
                                    Clear Filter
                                </button>
                            </div>
                            <div className="pt-3 flex justify-end w-[70%]">
                                <button
                                    type="button"
                                    className="w-full sm:h-10 h-9 border border-[#555259] bg-[#555259] rounded-lg text-sm font-semibold apply text-[#FFFFFF]"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    onClick={() => generateFilterQuery()}
                                >
                                    Apply Filter
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FilterModal;
